import { BoxWrapper, LicenseSelector } from '@common/components'
import React, { FunctionComponent, useEffect } from 'react'
import { get, isEmpty, isNumber } from 'lodash-es'
import { SKUSelectorsResponse } from '@buy/components/VolumeComponentWrapper'
import { OrderSummaryLine } from '@buy/state/order-summary/order-summary'
import {
    createOrUpdateCheckoutSessionState,
    getCheckoutSessionState,
    SessionKeys,
    setCheckoutSessionState,
} from '@buy/utils'
import { ParamTypes } from '@buy/Routes'
import { useParams } from 'react-router-dom'
import styles from '../../connectedComponents/Customize/customize.module.css'

export interface PlusMinusComponentProps extends SKUSelectorsResponse {
    title: string
    description: string
    showAdditionalLines: boolean
    baseLine: OrderSummaryLine
    setBaseLine: (value: OrderSummaryLine) => void
    isYearlyBillingFrequency: boolean
    currencyCode: string
    onChange: (value: number) => void
    value: number
}

export const PlusMinusComponent: FunctionComponent<PlusMinusComponentProps> = ({
    title,
    description,
    baseLine,
    setBaseLine,
    volumeSelector,
    unit,
    onChange,
    value,
    sku,
}) => {
    const { pathProduct, plan } = useParams<ParamTypes>()

    const onChangeValue = (input: number) => {
        onChange(input)
        const tempBaseLine: OrderSummaryLine = {
            ...baseLine,
            multiplier: input,
            quantity: Number(input),
        }
        setBaseLine(tempBaseLine)
        createOrUpdateCheckoutSessionState({ [`${sku}`]: input }, SessionKeys.volumeFields, pathProduct!, plan!)
        setCheckoutSessionState(tempBaseLine, SessionKeys.baseLine, pathProduct!, plan!)
    }

    useEffect(() => {
        const sessionState = getCheckoutSessionState(pathProduct!, plan!)
        const hasSessionValue =
            !isEmpty(sessionState) && isNumber(get(sessionState, `${SessionKeys.volumeFields}.${sku}`))
        if (hasSessionValue) onChange(Number(sessionState!.volumeFields[sku]))
        else onChange(volumeSelector!.minimum!)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [volumeSelector])

    return (
        <React.Fragment key={unit.id}>
            <BoxWrapper data-qat="plan-license-selection">
                <h3>{title?.replace('{0}', `${value}`)}</h3>
                <div>{description || ''}</div>
                {/* {isAddonFlow && (
                    <p>
                        <strong>{state.content.additionalUserLicences}:</strong> {state.content.howManyMore}
                    </p>
                )} */}
                {!isEmpty(volumeSelector) ? (
                    <div className={styles.license}>
                        <LicenseSelector
                            name={unit.unitName}
                            theme="dark"
                            organizers={value}
                            setOrganizers={onChangeValue}
                            min={volumeSelector.minimum!}
                            max={volumeSelector.maximum!}
                            error={volumeSelector.maximumReachedMessage!}
                            qaTag="license-quantity"
                        />
                        <span className={styles.label}>
                            {/* {state.isUserLoggedIn && state.existingAccountInformation
                                ? `${state.existingAccountInformation.quantity} ${
                                      state.existingAccountInformation.quantity > 1
                                          ? state.content.existingUserLicencePlural
                                          : state.content.existingUserLicense
                                  } + ${state.organizers} ${state.content.additional}`
                                : `${
                                      state.organizers > 1 ? state.content.quantityLabelPlural : state.content.quantityLabel
                                  }`} */}
                            {value > 1 ? unit.unitNamePlural : unit.unitName}
                        </span>
                    </div>
                ) : (
                    <></>
                )}
            </BoxWrapper>
        </React.Fragment>
    )
}
